import React from 'react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kundlishastra';
// iOS app is not live yet — update this once it ships, then flip IOS_AVAILABLE to true.
const APP_STORE_URL = 'https://apps.apple.com/app/kundli-shastra/idXXXXXXXXX';
const IOS_AVAILABLE = false;

const FEATURES = [
  { icon: '⚡', text: 'Faster performance' },
  { icon: '🔔', text: 'Better notifications' },
  { icon: '🤖', text: 'Personalised AI guidance' },
  { icon: '🌟', text: 'App-exclusive tools' },
];

/**
 * Premium feature-announcement style promo for the mobile app — intentionally
 * styled to feel like part of the product, not an ad banner.
 */
export default function MobileAppCTA({ style = {} }) {
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '20px',
        padding: 'clamp(1.5rem, 4vw, 2.25rem)',
        background: 'linear-gradient(135deg, #78350f 0%, #b45309 55%, #d97706 100%)',
        boxShadow: '0 10px 30px rgba(120,53,15,0.28)',
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute', top: -40, right: -40, width: 180, height: 180,
          borderRadius: '50%', background: 'rgba(255,255,255,0.08)',
        }}
      />
      <div style={{ position: 'relative', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1.5rem', justifyContent: 'space-between' }}>
        <div style={{ flex: '1 1 280px', minWidth: 0 }}>
          <span style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', color: '#fef3c7', fontSize: '0.68rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', padding: '0.25rem 0.7rem', borderRadius: '999px', marginBottom: '0.75rem' }}>
            New · Mobile App
          </span>
          <h3 style={{ color: '#fff', fontWeight: 800, fontSize: 'clamp(1.1rem, 3vw, 1.4rem)', margin: '0 0 0.5rem', lineHeight: 1.3 }}>
            Get the Complete Kundli Shastra Experience
          </h3>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.88rem', lineHeight: 1.6, margin: '0 0 1.1rem', maxWidth: '32rem' }}>
            Download our mobile app to unlock exclusive astrology tools, faster performance,
            personalised AI guidance, better notifications, and app-exclusive features.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.9rem', marginBottom: '1.25rem' }}>
            {FEATURES.map((f) => (
              <span key={f.text} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.76rem', color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>
                <span style={{ fontSize: '0.95rem' }}>{f.icon}</span> {f.text}
              </span>
            ))}
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.65rem 1.3rem',
                borderRadius: '0.75rem', background: '#fff', color: '#78350f', fontWeight: 700,
                fontSize: '0.85rem', textDecoration: 'none', boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
              }}
            >
              📲 Download the App
            </a>
            {IOS_AVAILABLE ? (
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.65rem 1.3rem',
                  borderRadius: '0.75rem', background: 'rgba(255,255,255,0.12)', border: '1.5px solid rgba(255,255,255,0.4)',
                  color: '#fff', fontWeight: 700, fontSize: '0.85rem', textDecoration: 'none',
                }}
              >
                 App Store
              </a>
            ) : (
              <span
                title="iOS app launching soon"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.65rem 1.3rem',
                  borderRadius: '0.75rem', background: 'rgba(255,255,255,0.08)', border: '1.5px dashed rgba(255,255,255,0.35)',
                  color: 'rgba(255,255,255,0.7)', fontWeight: 700, fontSize: '0.85rem', cursor: 'default',
                }}
              >
                 App Store · Coming Soon
              </span>
            )}
          </div>
        </div>

        <div style={{ fontSize: 'clamp(3rem, 8vw, 4.5rem)', flexShrink: 0, filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.25))' }} aria-hidden="true">
          📱
        </div>
      </div>
    </div>
  );
}
